import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'nf-task-filter',
  templateUrl: './task-filter.component.html',
  styleUrls: ['./task-filter.component.less']
})
export class TaskFilterComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  filterData = {
    groups: [],
    columns: []
  };
  filterColumnExclude = ['progress', 'time-interval', 'relation-data', 'button', 'vote', 'createTime', 'taskStatus', 'taskHandle', 'taskButton']; // 不支持筛选的列
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  constructor() { }

  ngOnInit(): void {
  }
  // 使用历史筛选条件
  useLastCondition() {}
  // 清除筛选
  clearFilterCondition() {}
}
